import clientConfig from '../client/config';
import { Request } from 'express';
import { createAuth as _createAuth } from '@justgiving/auth';

const {
  authCookieName,
  activeGroupCookieName,
  refreshAccessTokenApi: refreshAccessTokenUrl,
} = clientConfig;

export function createAuth(documentOrReq: Document | Request) {
  return _createAuth({
    documentOrReq,
    authCookieName,
    activeGroupCookieName,
    refreshAccessTokenUrl,
  });
}
